
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { defineComponent } from 'vue';
import BaseModal from './BaseModal.vue';

export default defineComponent({
  name: 'ConfirmationModal',

  components: {
    BaseModal,
    ButtonCustom,
  },

  props: {
    isDisplay: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    cancelText: {
      type: String,
      default: 'Hủy bỏ',
    },
    confirmText: {
      type: String,
      default: 'Xác nhận',
    },
    width: {
      type: String,
      default: '50%',
    },
    size: {
      type: String,
      default: 'sm',
      validator: (value: string) => ['', 'sm', 'lg', 'xl'].includes(value),
    },
  },

  emits: ['close', 'confirm'],

  setup() {
    const { ButtonsType, ButtonTypeColors } = useButtonCustom();

    return {
      ButtonsType,
      ButtonTypeColors,
    };
  },

  data() {
    return {
      isConfirming: false,
    };
  },

  watch: {
    isDisplay(newValue: boolean) {
      if (!newValue) {
        this.isConfirming = false;
      }
    },
  },

  methods: {
    onClose() {
      if (this.isConfirming) {
        return;
      }

      this.$emit('close');
    },

    onConfirm() {
      if (this.isConfirming) {
        return;
      }

      this.isConfirming = true;
      this.$emit('confirm');
    },

    resetConfirmingState() {
      this.isConfirming = false;
    },
  },
});
